<template>
  <div class="section-text-style">
    <ul class="editor-design">
      <li>
        テキスト
      </li>
      <li class="flex-box end">
        <!-- フォント -->
        <select-box
          :target="'font-family-name'"
          :value="styles['font-family-name']"
          @updateStyles="updateStyles($event)"
        />
        <!-- 揃え位置 -->
        <select-button
          :target="'text-align'"
          :value="styles['text-align']"
          @updateStyles="updateStyles($event)"
        />
      </li>
      <li class="flex-box">
        <!-- フォントサイズ -->
        <select-box
          :target="'font-size'"
          :value="styles['font-size']"
          @updateStyles="updateStyles($event)"
        />
        <!-- 行の高さ -->
        <select-box
          :target="'line-height'"
          :value="styles['line-height']"
          @updateStyles="updateStyles($event)"
        />
        <!-- 文字色 -->
        <select-color
          :type="'section'"
          :target="'color'"
          :selector="null"
          :value="styles['color']"
          @updateStyles="updateStyles($event)"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import SelectColor from '@/components/Content/Palette/CommonLayouts/EditStyleSelectColor'
import SelectBox from '@/components/Content/Palette/CommonLayouts/EditStyleSelectBox'
import SelectButton from '@/components/Content/Palette/CommonLayouts/EditStyleSelectButton'

export default {
  props: [
    'sectionName',
    'styles',
  ],
  components: {
    SelectColor,
    SelectBox,
    SelectButton,
  },
  methods: {
    updateStyles (styles) {
      this.$store.commit('updateSectionStyles', {
        sectionName: this.sectionName,
        styles: styles
      })
    },
  },
}
</script>

<style lang="scss">
.section-text-style {
  .editor-design {
    .flex-box {
      &.end {
        align-items: flex-end;
      }
    }
  }
}
</style>
